<script>
	import { onMount } from "svelte";
	import { isInViewport } from "../utils";

	export let options = [];
	export let onToggle = null;
	export let values = [];
	export let title;
	export let includeAllOption = false;
	export let multiselect = false;

	let container;
	let rightEnd = false;
	let leftEnd = true;

	const checkForGradient = () => {
		const difference = container.scrollLeft + container.offsetWidth - container.scrollWidth;
		rightEnd = Math.abs(difference) < 1;
		leftEnd = container.scrollLeft < 1;
	};

	onMount(() => {
		checkForGradient();
	});

	const allOption = {
		id: "all",
		label: "Alle",
	};

	const allOptions = includeAllOption ? [allOption, ...options] : options;
</script>

{#if title}
	<div class="title">
		{@html title}
	</div>
{/if}
<div class="container" tabindex="-1">
	<div
		class="filters"
		bind:this={container}
		role="list"
		aria-label="Filter options"
		on:scroll={() => {
			checkForGradient();
		}}
	>
		{#each allOptions as o, j}
			{@const active =
				o.id === "all" ? values.length === options.length : values.includes(o.id) && values.length !== options.length}
			{@const width = o.width ? `${o.width}px` : null}
			{@const isFirst = j === 0}
			{@const isLast = j === allOptions.length - 1}
			{@const isMiddle = !isFirst && !isLast}

			<div
				class="filter"
				class:active
				role="listitem"
				style="--background-color: {o.color || '#090909'}"
				style:width
				bind:this={o.elem}
				on:click={(e) => {
					if (multiselect) {
						// if all option is selected
						if (o.id === "all") {
							// and all options are selected --> deselect all
							if (values.length === options.length) {
								values = [];
								// and not all options are selected --> select all
							} else {
								values = options.map((o) => o.id);
							}
							// if all option is not selected
						} else {
							// if all other options are selected --> deselect all and select this option
							if (values.length === options.length) {
								values = [o.id];
							}
							// and the option is already selected --> deselect it
							else if (values.includes(o.id)) {
								values = values.filter((v) => v !== o.id);
								// and the option is not selected --> select it
							} else {
								values = [...values, o.id];
							}
						}
					} else {
						if (o.id == "all") {
							values = options.map((o) => o.id);
						} else {
							values = [o.id];
						}
					}

					if (onToggle) onToggle(o);
					if (!isInViewport(o.elem))
						container.scrollTo({
							left: j === 0 ? 0 : o.elem.offsetLeft - 10,
							behavior: "smooth",
						});
				}}
			>
				<slot option={o} {active} aria-label="filter option" />
			</div>
		{/each}
	</div>
</div>

<style lang="scss">
	@import "../main.scss";
	$btn-black: #090909;

	.title {
		font-weight: $medium;
		font-size: 12px;
		margin-bottom: 8px;
		letter-spacing: 0.6px;
		text-transform: uppercase;
		opacity: 0.7;
	}

	.container {
		position: relative;

		&:focus {
			outline: none;
		}
	}

	.filters {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		width: fit-content;
		align-items: center;
		column-gap: 5px;
		row-gap: 7px;

		@media (max-width: $breakpoint-mobile-m) {
		}

		&::-webkit-scrollbar {
			display: none;
		}
	}

	.filter {
		position: relative;
		white-space: nowrap;
		user-select: none;
		-webkit-tap-highlight-color: transparent;
		cursor: pointer;
		transition: background-color 0.3s ease, color 0.3s ease;
		color: #2a2a2a;
		font-weight: $medium;
		font-size: 15px;
		letter-spacing: 0.15px;
		border-radius: 56px;
		border: 1px solid #fff0;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #f5f5f5;
		padding: 8px 13px;
		min-width: 70px;

		@media (max-width: $breakpoint-mobile-l) {
			padding: 5px 10px;
			height: 36px;
			font-size: 13px;
		}

		&:hover {
			background: #e6e7ed;
			box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.12);
		}
	}

	.filter.active {
		color: #fff;
		background: var(--background-color);
		border: 1px solid #fff;
		box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.12);
	}
</style>
